import { useTranslation } from 'react-i18next'
import {
  PrivateReportsStudiesObjectsCompareGroupTypesConfig,
  StudiesObjectsCompareGroupTypesConfig,
  StudyObjectType,
} from '../configs/StudiesObjectsCompareGroupTypesConfig'
import { StudyObjectValueType } from '../../../../../store/interfaces/analytics-details/new-readership-profile-state.interface'
import { SetColorConfig } from '../../../../../core/config/SetColorConfig'
import { BookInterface } from '../../../../../core/interface/book.interface'
import ReadershipProfileInputTypeChoice from './ReadershipProfileInputTypeChoice'
import { DateFilterTypeEnum } from '../../../../../core/enums/date-filter-type.enum'
import NewReadershipProfileBookFiltersInterface from '../../../../../core/interface/analytics/new-readership-profile-book-filters'

const StudyObjectSelection = ({
  disable,
  studyObjectType,
  studyObjectValue,
  handleOnClickInputSelectionButton,
  handleSelectValue,
  booksSelected,
  handleUpdateBooksSelected,
  handleOpenBookDetails,
  eanSelected,
  filtersActions,
  handleOnChangeFilter,
  isPrivate = false,
}: {
  disable: boolean
  studyObjectType: StudyObjectType
  studyObjectValue: StudyObjectValueType
  handleOnClickInputSelectionButton: (value: StudyObjectType) => void
  handleSelectValue: (value: StudyObjectValueType) => void
  booksSelected: BookInterface[]
  handleUpdateBooksSelected: (books: BookInterface[]) => void
  handleOpenBookDetails: (eanId: number | null) => void
  eanSelected: number | null
  filtersActions: NewReadershipProfileBookFiltersInterface
  handleOnChangeFilter: (
    key: string | number,
    newList: Array<string | number | null> | DateFilterTypeEnum,
  ) => void
  isPrivate?: boolean
}) => {
  const { t } = useTranslation()
  return (
    <ReadershipProfileInputTypeChoice<StudyObjectType, StudyObjectValueType>
      disable={disable}
      keyValue="study-object"
      color={SetColorConfig[0].color1}
      title={t('iStudyTheReadersOfNew')}
      subTitle={t('StudyObject')}
      inputsTypeConfig={
        isPrivate
          ? PrivateReportsStudiesObjectsCompareGroupTypesConfig
          : StudiesObjectsCompareGroupTypesConfig
      }
      inputTypeSelected={studyObjectType}
      inputValue={studyObjectValue}
      handleOnClickInputSelectionButton={handleOnClickInputSelectionButton}
      handleSelectValue={handleSelectValue}
      booksSelected={booksSelected}
      handleUpdateBooksSelected={handleUpdateBooksSelected}
      handleOpenBookDetails={handleOpenBookDetails}
      eanSelected={eanSelected}
      filtersActions={filtersActions}
      handleOnChangeFilter={handleOnChangeFilter}
      isPrivate={isPrivate}
    />
  )
}

export default StudyObjectSelection
